import React from 'react';
import styled from 'styled-components';
import PropTypes, { shape } from 'prop-types';
import I10n from '../features/i10n';
import Device from '../models/Device';

const Container = styled.div`
`;

const Title = styled.h3`
  margin: 0;
  margin-bottom: 4px;
  padding: 0;
  font-size: 12px !important;
  line-height: 16px !important;
  color: #333333;
  font-weight: bold;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

const Option = styled.div`
  display: flex;
  padding: 5px 10px;
  position: relative;
  background-color: ${props => props.selected ? '#626469' : ''};
  color: ${props => props.selected ? 'white' : ''};
  border: 1px solid ${props => props.selected ? '#626469' : '#E7E6E6'};
  cursor:  ${props => props.isLoading ? 'not-allowed' : 'pointer'};
`;

const FuseText = styled.span`
  font-size: 10px;
`;

const OptionMask = styled.div`
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  background-color: grey;
  z-index: 1;
  opacity: 0.2;
`;

class FuseSettings extends React.Component {

  static propTypes = {
    module: shape(Device),
    isLoading: PropTypes.bool,
    onFuseClick: PropTypes.func,
  }

  render = () => {
    return (
      <Container>
        <Title>{I10n.get('module_setting.information.fuse')}</Title>
        <Row>
          {Object.entries(this.props.module.relatedFuseDevices).map(([hasFuseStr, referenceID]) => {
            const hasFuse = hasFuseStr === "true";
            const fuseSelected = this.props.module.hasFuse === hasFuse;
            return (
              <Option
                key={hasFuseStr}
                selected={fuseSelected}
                isLoading={this.props.isLoading}
                onClick={() => {
                  if (!fuseSelected) {
                    this.props.onFuseClick(referenceID);
                  }
                }}
              >
                <FuseText>{hasFuse ? I10n.get('app.common.with') : I10n.get('app.common.without')}</FuseText>
                {this.props.isLoading && <OptionMask></OptionMask>}
              </Option>
            )
          })}
        </Row>
      </Container>
    );
  }
}
export default FuseSettings;
